import {
    GET_TRANSACTIONS,
    GET_TRANSACTIONS_SUCCESS,
    GET_TRANSACTIONS_FAILED,

    SUBMIT_TRANSACTION_FORM,
    SUBMIT_TRANSACTION_FORM_SUCCESS,
    SUBMIT_TRANSACTION_FORM_FAILED,

    DELETE_TRANSACTION,
    DELETE_TRANSACTION_SUCCESS,
    DELETE_TRANSACTION_FAILED,

    IMPORT_TRANSACTIONS,
    IMPORT_TRANSACTIONS_SUCCESS,
    IMPORT_TRANSACTIONS_FAILED,

    GET_TRANSACTIONS_COUNT,
    GET_TRANSACTIONS_COUNT_SUCCESS,
    GET_TRANSACTIONS_COUNT_FAILED,

    GET_CURRENT_TRANSACTION,
    GET_CURRENT_TRANSACTION_SUCCESS,
    GET_CURRENT_TRANSACTION_FAILED
} from '../../constants/actionTypes';

const INIT_STATE = {
    loading: false,
    transactions: [],
    submittingForm: false,
    error: null,
    deleting: false,
    importing: false,
    unreadCount: 0,
    currentTransaction: null,
};

const TransactionReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_TRANSACTIONS:
            return { ...state, loading: true };
        case GET_TRANSACTIONS_SUCCESS:
            return { ...state, transactions: action.payload.data, total: action.payload.total, loading: false, error: null };
        case GET_TRANSACTIONS_FAILED:
            return { ...state, error: action.payload, loading: false };

        
        case GET_CURRENT_TRANSACTION:
            return { ...state, loading: true };
        case GET_CURRENT_TRANSACTION_SUCCESS:
            return { ...state, currentTransaction: action.payload, loading: false, error: null };
        case GET_CURRENT_TRANSACTION_FAILED:
            return { ...state, error: action.payload, loading: false };
    

        case GET_TRANSACTIONS_COUNT:
            return { ...state, loading: true };
        case GET_TRANSACTIONS_COUNT_SUCCESS:
            return { ...state, unreadCount: action.payload.total, loading: false, error: null };
        case GET_TRANSACTIONS_COUNT_FAILED:
            return { ...state, error: action.payload, loading: false };

        case SUBMIT_TRANSACTION_FORM:
            return { ...state, error: null, submittingForm: true };
        case SUBMIT_TRANSACTION_FORM_SUCCESS:
            if(action.payload && action.payload.id) {
                const alreadyExists = state.transactions.find((transaction) => transaction.id === action.payload.id);
                let transactions;
                let total = state.total;
                if (!alreadyExists) {
                    transactions = [action.payload, ...state.transactions];
                    total += 1;
                } else {
                        transactions = state.transactions.map((transaction) => {
                        if (transaction.id === action.payload.id) {
                        return action.payload;
                        }
                        return transaction;
                    });
                }
                return { ...state, total,  transactions, submittingForm: false };
            }
            return { ...state, submittingForm: false };
        case SUBMIT_TRANSACTION_FORM_FAILED:
            return { ...state, error: action.payload, submittingForm: false };

        case DELETE_TRANSACTION:
            return { ...state, error: null, deleting: true };
        case DELETE_TRANSACTION_SUCCESS:
            return { ...state, total: state.total - 1, transactions: state.transactions.filter(transaction => transaction.id !== action.payload) , deleting: false };
        case DELETE_TRANSACTION_FAILED:
            return { ...state, error: action.payload, deleting: false };

        case IMPORT_TRANSACTIONS:
            return { ...state, error: null, importing: true };
        case IMPORT_TRANSACTIONS_SUCCESS:
            return { ...state, importing: false };
        case IMPORT_TRANSACTIONS_FAILED:
            return { ...state, error: action.payload, importing: false };

        default: return { ...state };
    }
}

export default TransactionReducer;